import { Tab, Tabs } from "@mui/material";
import { Add } from "@mui/icons-material";

/** Sentinel value emitted by onSelect when the user clicks the trailing
 * "+" tab. The parent opens an AddDiseaseAreaDialog in response. */
export const ADD_DA_TAB = "__add_da__";

interface Props {
  /** Only DAs the site is enrolled in. The trailing "+" tab handles
   * adding new ones via the picker dialog. */
  diseaseAreas: { code: string; name: string }[];
  active: string;
  onSelect: (codeOrAdd: string) => void;
}

export function DiseaseAreaTabBar({ diseaseAreas, active, onSelect }: Props) {
  // Tabs requires `value` to match one of the rendered tab values, so
  // when the user clicks "+" we don't actually mark it active; the
  // parent opens a dialog and the active tab stays put.
  return (
    <Tabs
      value={diseaseAreas.some((d) => d.code === active) ? active : false}
      onChange={(_e, v) => onSelect(v)}
      sx={{ borderBottom: 2, borderColor: "divider", mt: 3 }}
    >
      {diseaseAreas.map((da) => (
        <Tab key={da.code} value={da.code} label={da.name} />
      ))}
      <Tab
        value={ADD_DA_TAB}
        icon={<Add fontSize="small" />}
        iconPosition="start"
        label="Add"
        aria-label="Add disease area"
        sx={{ minHeight: 48 }}
      />
    </Tabs>
  );
}
